import { Checkbox } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { haltClickEventPropagation } from '@lib/events';
import { useIsFollowing } from '@hooks/followers/useIsFollowing';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';
import React, { useCallback } from 'react';
import { useCurrentUser, useFeatureFlag } from '@hooks';
export const FollowCheckbox = ({ sonarObjectId }) => {
    const checked = useIsFollowing(sonarObjectId);
    const { follow, unfollow } = useUpdateFollowing([sonarObjectId]);
    const { isReadOnly } = useCurrentUser();
    const enabled = useFeatureFlag(FeatureFlag.Followers);
    const handleOnChange = useCallback(() => {
        if (checked) {
            unfollow();
        }
        else {
            follow();
        }
    }, [checked, follow, unfollow]);
    if (!enabled) {
        return null;
    }
    if (isReadOnly) {
        return checked ? React.createElement(CheckCircleOutlined, null) : null;
    }
    return (React.createElement("div", { className: 'follow-checkbox', onClick: haltClickEventPropagation },
        React.createElement(Checkbox, { checked: checked, onChange: handleOnChange })));
};
